export default {
  skip_to_main_content: 'Przejdź do głównej treści',
  show_system_messages: 'Pokaż komunikaty systemowe',
  dont_show_system_messages: 'Ukryj komunikaty systemowe',
  logged_in: 'Najemca jest uwierzytelniony',
  logged_out: 'Anonimowy użytkownik',
  button_tooltip_switch_locale: 'Zmień język',
  button_tooltip_activate_voice_recognition: 'Włącz rozpoznawanie mowy',
  date_input: 'Wybierz datę',
  choose_two_dates: 'Proszę wybrać dwie daty',
  date_range: 'Zakres dat',
  from: 'z',
  to: 'do',
  avatar: 'awatar',
  exit: 'koniec',
  new: 'nowy',
  back: 'wstecz',
  address: 'adres',
  suggestions: 'propozycje',
  senton: 'wysłane',
  message_placeholder: 'Tutaj napisz wiadomość...',
  message_aria: 'Tutaj napisz wiadomość',
  upload_in_progress: 'Przesyłanie trwa...',
  comment_placeholder: 'Napisz komentarz tutaj',
  message_button_label: 'Senden',
  please_confirm: 'Proszę potwierdzić',
  no: 'Nie',
  yes: 'Tak',
  modal_delete_session: 'usuń sesję',
  modal_delete_session_notification:
    'Jeśli zamkniesz okno, Twoja sesja również zostanie usunięta.<br>Zgadzasz się z tym?',
  template_contact_time: 'Kiedy możemy się z Tobą skontaktować?',
  template_pause:
    'Twoja sesja została wstrzymana. Wkrótce jeden z naszych pracowników pomocniczych zajmie się twoją prośbą.',
  template_continue_after_pause:
    'Twoja sesja zostala wznowiona. Możesz teraz kontynuować rozmowę z naszym chatbotem.',
  choose_date: 'Proszę wybrać datę',
  button_apply: 'Przejąć',
  button_cancel: 'Anulować',
  none: 'None',
  book_appointment: 'zarezerwować wizytę',
  address_input: 'wpis adresu',
  data_processing: 'przetwarzanie danych',
  privacy_policy: 'Ochrona danych',
  data_processing_notification_before_link:
    'Aby móc korzystać z tej usługi czatu, konieczne jest posiadanie ',
  data_processing_notification_after_link: 'zaakceptować.',
  button_accept: 'zaakceptować',
  select_date: 'Wybierz datę',
  rate_conversation: 'Jak oceniasz tę rozmowę?',
  new_ticket_question: 'Czy jest coś jeszcze, co mogę dla ciebie zrobić?',
  thank_you:
    'Dziękuję za Twoje wsparcie. Twoja opinia pomaga mi w ciągłym doskonaleniu',
  goodbye: 'Do zobaczenia',
  start_new: 'Rozpocznij nową rozmowę',
  operator_entered_the_chat: 'Operator wszedł na czat',
  operator_left_the_chat: 'Operator opuścił czat',
  bg_image: process.env.VUE_APP_DE_BG,
  expand_quickreplies: 'Więcej',
  collapse_quickreplies: 'mniej',
  login: 'Zaloguj sie',
  logout: 'Wyloguj sie',
  close: 'Zamknij',
  messenger_text:
    'Możesz napisać za pomocą naszego chatbota lub skontaktować się bezpośrednio z jednym z naszych pracowników na naszym czacie na żywo.',
  chat_bot: 'Chatbot',
  live_bot: 'Live Chat',
  maximize: 'Powiekrzyc',
  minimize: 'Zmniejszyc',
  upload_file: 'Upuść plik tutaj, aby go przesłać',
  upload_file_or: 'lub',
  Upload_file_select: 'Dodaj pliki',
  upload_file_text: 'Upuść plik, aby go przesłać',
  show_attachments: 'Wyświetl załącznik',
  hide_attachments: 'Ukryj załącznik',
  tooBig: 'Plik jest za duży',
  tooSmall: 'Plik jest za maly',
  showMore: 'Pokaż więcej',
  showLess: 'Pokaż mniej',
  uploadTooltip: 'Prześlij plik',
  uploadFilesTooltip: 'Prześlij pliki',
  pdfDownloadTooltip: 'Pobierz Rozmowa',
  feedbackDescription: 'Iinformację zwrotną',
  feedbackSubtitle: {
    description:
      'Tutaj możesz wysłać nam ogólne sugestie, propozycje i prośby.',
    note: 'Prosimy pamiętać, że nie możemy na nie odpowiedzieć.',
    hint:
      'Wszystkie inne wątpliwości, które konkretnie dotyczą najmu lub poszukiwania mieszkania, można nam opisać na czacie.'
  },
  feedbackPlaceholder: 'Wpisz tutaj swoją wiadomość...',
  sendFeedback: 'Wyślij',
  giveFeedback: 'Iinformację zwrotną',
  feedbackSubmittedSuccessfully: 'Twoja opinia została pomyślnie wysłana',
  character_limit: 'Znaki',
  page: 'p.',
  factually_incorrect: 'Nie faktycznie poprawne',
  not_following_instructions: 'Nie przestrzegał instrukcji w pełni',
  info_not_in_document: 'Informacja nie znaleziona w dokumencie',
  inappropriate_or_offensive: 'Niewłaściwy lub obraźliwy',
  irrelevant: 'Niezwiązane',
  not_fitting_topic: 'Nie pasujący do tematu',
  confusing_information: 'Mylące informacje',
  ignored_important_parts_of_document: 'Zignorowane ważne części dokumentu',
  interpreted_document_wrong: 'Błędne zinterpretowanie dokumentu',
  answer_to_generic: 'Odpowiedź zbyt ogólna',
  sources_incorrect: 'Niepoprawne lub niezawodne źródła',
  invalidFileTypeCopilot:
    'Nieprawidłowy typ pliku. Obecnie obsługiwane są tylko typy plików .png, .jpg, .jpeg, .gif.',
  tooManyFiles: 'Proszę przesłać maksymalnie 5 plików naraz',
  chatProtocol: 'ChatProtokół',
  feedbackInfoPlaceholder: 'Dodaj tutaj szczegółowe informacje...',
  why_not_helpful: 'Dlaczego to nie było pomocne?',
  thank_you_feedback: 'Dziękuję za Twoją opinię!',
  provide_feedback: 'Przekaż opinię na temat tej odpowiedzi',
  not_helpful: 'Nie pomocne',
  helpful: 'Pomocne',
  regenerate_message: 'Regeneruj',
  copy_message: 'Kopiuj',
  copied_message: 'Skopiowane!',
  original_answer: 'Oryginalna odpowiedź',
  regenerated_answer: 'Regenerowana odpowiedź',
  thinking_message: 'Myślę...',
  file_path: 'Ścieżka pliku: ',
  new_messages: 'Nowe wiadomości',
  previous_message: 'Poprzednia wiadomość',
  next_message: 'Następna wiadomość',
  clear_input: 'Wyczyść wprowadzenie',
  open_feedback: 'Otwórz opinię',
  file_upload: 'Przesyłanie pliku',
  expand_quickreplies_aria: 'Pokaż więcej przycisków',
  button_tooltip_switch_locale_german: 'Zmień język na niemiecki',
  button_tooltip_switch_locale_french: 'Zmień język na francuski',
  button_tooltip_switch_locale_dutch: 'Zmień język na holenderski',
  button_tooltip_switch_locale_turkish: 'Zmień język na turecki',
  button_tooltip_switch_locale_russian: 'Zmień język na rosyjski',
  button_tooltip_switch_locale_swedish: 'Zmień język na szwedzki',
  button_tooltip_switch_locale_ukranian: 'Zmień język na ukraiński',
  button_tooltip_switch_locale_spanish: 'Zmień język na hiszpański',
  button_tooltip_switch_locale_polish: 'Zmień język na polski',
  button_tooltip_switch_locale_arabic: 'Zmień język na arabski',
  button_tooltip_switch_locale_italian: 'Zmień język na włoski',
  button_tooltip_switch_locale_english: 'Zmień język na angielski',
  message_from_you: 'Mówisz',
  message_from_bot: 'Bot mówi',
  message_from_operator: 'Agent mówi',
  new_message_from_bot: 'Bot mówi',
  empty_message_received: 'Otrzymano pustą wiadomość'
}
